import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import './PodcastListing.css';

const API_URL = process.env.REACT_APP_API_URL;

const PodcastWebView = () => {
  const [podcast, setPodcasts] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchPodcasts = async () => {
      const response = await fetch(`${API_URL}/getAllPodcasts`);
      const data = await response.json();
      console.log(data, "Fetched Podcasts");

      if (data?.data?.length === 1) {
        navigate(`/podcast/${data?.data[0]?._id}`);
      }
      setPodcasts(data?.data || []);
    };

    fetchPodcasts();
  }, []);

  const getEmbedComponent = (url) => {
    try {
      const parsedUrl = new URL(url);

      // YouTube
      if (parsedUrl.hostname.includes("youtu.be") || parsedUrl.hostname.includes("youtube.com")) {
        let videoId = "";
        if (parsedUrl.hostname.includes("youtu.be")) {
          videoId = parsedUrl.pathname.substring(1).split("?")[0];
        } else if (parsedUrl.hostname.includes("youtube.com")) {
          videoId = parsedUrl.searchParams.get("v");
        }

        return videoId ? (
          <iframe
            width="100%"
            height="200"
            src={`https://www.youtube.com/embed/${videoId}`}
            title="YouTube Video"
            className="rounded-lg"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          ></iframe>
        ) : (
          <p className="text-red-500">Video not available</p>
        );
      }

      // Spotify
      if (parsedUrl.hostname.includes("spotify.com")) {
        const embedUrl = url.replace("open.spotify.com", "embed.spotify.com");
        return (
          <iframe
            src={embedUrl}
            width="100%"
            height="152"
            frameBorder="0"
            allow="encrypted-media"
            className="rounded-lg"
          ></iframe>
        );
      }
    } catch (error) {
      console.error("Invalid media URL:", url);
    }

    return <p className="text-gray-500">Media not available</p>;
  };

  return (
    <div className="blog-listing" >
      <div className="blog-container grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {podcast.length > 0 ? (
          podcast.map((podcast) => (
            <div className="relative blog-card bg-white rounded-lg shadow-lg overflow-hidden" key={podcast._id}>
              <div className="relative">
                {getEmbedComponent(podcast.link)}
              </div>

              <div className="p-4">
                <h2 className="text-lg font-bold">{podcast.title}</h2>
                <p className="text-gray-600">
                  {podcast.description?.substring(0, 100)}...
                </p>
              
              </div>
            </div>
          ))
        ) : (
          <p className="text-gray-600 text-center">Loading podcasts...</p>
        )}
      </div>
    </div>
  );
};

export default PodcastWebView;
